import Saver from '@/utils/searchParamsSaver.js';

export const loadingMixin = {
  data() {
    return {
      isLoading: false
    };
  },

  beforeDestroy() {
    this.$store.commit('SET_PAGE_LOADING', false);
  },

  watch: {
    isLoading(val) {
      this.$store.commit('SET_PAGE_LOADING', val);
    }
  }
};

export const statusClassesMixin = {
  methods: {
    statusClass(status) {
      switch (status) {
        case 'active':
        case 'approved':
        case 'enabled':
          return 'success';
        case 'closed':
        case 'rejected':
        case 'disabled':
          return 'danger';
        case 'no funds':
          return 'warning';
        case 'pending':
          return 'info';
        default:
          return 'info';
      }
    }
  }
};

export const saverMixin = {
  data() {
    return {
      saver: null
    };
  },

  created() {
    this.saver = new Saver(this.$router);
  }
};
